import { render } from "./BasicMultipleSelect.vue?vue&type=template&id=f1a889f2"
import script from "./BasicMultipleSelect.vue?vue&type=script&lang=js"
export * from "./BasicMultipleSelect.vue?vue&type=script&lang=js"
script.render = render

export default script